import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewContainerRef } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { UserOption } from 'src/app/pages/user-register/models/user-option.interface';
import { LCS_SINGLE_SELECT_OPTIONS, LcsSingleSelectBase } from '../../single-select/single-select-base';
import { userOptionSelectors } from '../state/user-option.reducer';

@Component({
    providers: [
        {
            provide: LCS_SINGLE_SELECT_OPTIONS,
            useExisting: UserSelectComponent,
        },
    ],
    selector: 'ndt-user-select',
    templateUrl: './user-select.component.html',
    standalone: false
})
export class UserSelectComponent extends LcsSingleSelectBase<UserOption> implements OnInit {
   users: Observable<UserOption[] | null>;

   constructor(
      protected elementRef: ElementRef,
      protected changeDetectorRef: ChangeDetectorRef,
      protected viewContainerRef: ViewContainerRef,
      private store: Store
   ) {
      super(elementRef, changeDetectorRef, viewContainerRef);
   }

   ngOnInit(): void {
      this.users = this.store.pipe(select(userOptionSelectors.selectFilteredItems), this.itemsLoaded());
   }

   displayWith(item: UserOption | null): string | null {
      return item ? item.name : null;
   }

   trackBy(item: UserOption | null) {
      return item ? item.userId : null;
   }
}
